var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerMenuActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 5.35026C14.625 2.80745 12.5636 0.746094 10.0208 0.746094C7.47802 0.746094 5.41667 2.80745 5.41667 5.35026C5.41667 7.89307 7.47802 9.95443 10.0208 9.95443C12.5636 9.95443 14.625 7.89307 14.625 5.35026Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2292 5.35026C19.2292 3.70491 17.8954 2.37109 16.25 2.37109C15.8013 2.37109 15.4375 2.00732 15.4375 1.55859C15.4375 1.10986 15.8013 0.746094 16.25 0.746094C18.7928 0.746094 20.8542 2.80745 20.8542 5.35026C20.8542 7.89307 18.7928 9.95443 16.25 9.95443C15.8013 9.95443 15.4375 9.59066 15.4375 9.14193C15.4375 8.69319 15.8013 8.32943 16.25 8.32943C17.8954 8.32943 19.2292 6.99561 19.2292 5.35026Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.678 19.279C19.8596 20.4476 18.8823 21.2956 17.8754 21.2956H2.16707C1.16015 21.2956 0.182853 20.4476 0.364447 19.279C1.03025 14.9943 5.14253 11.5794 10.0212 11.5794C14.9 11.5794 19.0122 14.9943 19.678 19.279Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1039 21.3293C25.11 21.3293 26.0897 20.4814 25.9043 19.3107C25.4175 16.2389 23.1217 13.5389 20.0418 12.448C19.6188 12.2982 19.1545 12.5197 19.0047 12.9426C18.8549 13.3656 19.0763 13.83 19.4993 13.9798C22.0474 14.8823 23.9106 17.1121 24.2993 19.565C24.3023 19.5842 24.3 19.5948 24.2977 19.6017C24.295 19.6101 24.2885 19.6233 24.2737 19.6389C24.2423 19.6719 24.1829 19.7043 24.1039 19.7043H22.4789C22.0302 19.7043 21.6664 20.0681 21.6664 20.5168C21.6664 20.9656 22.0302 21.3293 22.4789 21.3293H24.1039Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerMenuActive);
export default __webpack_public_path__ + "static/media/customer-menu-active.da1e67208cccc141a26dde240d8baa4a.svg";
export { ForwardRef as ReactComponent };